import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  DataBlocks,
  Tooltip,
} from 'components';

import { formatUnitString } from 'utils/formatString';

import BalanceTooltip from '../BalanceTooltip';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const AccountState = ({
  ban,
  firstName,
  lastName,
  invoiceAddr,
  nrtbcBalance,
  limit,
  arBalance,
  banBalance,
  banRemainLimit,
  currency,
}) => {
  if (!ban) return null;

  return (
    <DataBlocks.Block
      className="halfWidth"
      title={(
        <I18n
          path="home.accountState.title"
          vars={{ ban }}
        />
      )}
    >
      {lastName && firstName && (
        <div className={cx('row')}>
          <I18n
            className={cx('label')}
            path="home.accountState.owner"
          />
          {`${lastName} ${firstName}`}
        </div>
      )}

      {invoiceAddr && (
        <div className={cx('row')}>
          <I18n
            className={cx('label')}
            path="home.accountState.invoiceAddress"
          />
          {invoiceAddr}
        </div>
      )}

      {nrtbcBalance && typeof nrtbcBalance.value === 'number' && (
        <div className={cx('row')}>
          <I18n
            className={cx('label')}
            path="home.accountState.threshold"
          />
          {formatUnitString(nrtbcBalance.value, nrtbcBalance.currency)}
          <Tooltip>
            <I18n path="home.accountState.thresholdTooltip" />
          </Tooltip>
        </div>
      )}

      {banBalance && (
        <div className={cx('row')}>
          <I18n
            className={cx('label')}
            path="home.accountState.currentExpenses"
          />
          {formatUnitString(banBalance.value, banBalance.currency)}
        </div>
      )}

      <div className={cx('row')}>
        <I18n
          className={cx('label')}
          path="home.accountState.available"
        />
        {formatUnitString(banRemainLimit, currency)}
        <BalanceTooltip
          limit={limit}
          arBalance={arBalance}
          banRemainLimit={banRemainLimit}
          currency={currency}
        />
      </div>
    </DataBlocks.Block>
  );
};

AccountState.propTypes = {
  ban: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  invoiceAddr: PropTypes.string,
  nrtbcBalance: PropTypes.object,
  banBalance: PropTypes.object,
  limit: PropTypes.number,
  arBalance: PropTypes.number,
  banRemainLimit: PropTypes.number,
  currency: PropTypes.string,
};

export default AccountState;
